import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './auth-context';
import { AuthProviderContext } from 'auth-provider';

// Probably remove this
interface Props {
  children: React.ReactNode;
}

function AppProviders({ children }: Props) {
  return (
    <Router>
      <AuthProviderContext>
        {' '}
        <AuthProvider>{children}</AuthProvider>
      </AuthProviderContext>
    </Router>
  );
}

export { AppProviders };
